/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf


/**
 * The product page
 *
 * @type {angular.Module}
 */
module editor {
  'use strict';

  var nav = angular.module('Editor', ['ui.ace', 'angular-cache', 'ngMaterial', 'ngMessages', 'navigation', 'ngFileUpload'])
    .directive('editor', editor.EditorDirective)
    .directive('contentListItem', editor.ContentListItemDirective)
    .service('editorService', editor.EditorService)
    .controller('editorCtrl', editor.EditorCtrl)
    .filter('keyboardShortcut', editor.KeyboardShortcut)
    .filter('statusTopic', editor.StatusTopic)
    .filter('categoryTopic', editor.CategoryTopic)
    .filter('tagTopic', editor.TagTopic);

}